import React from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import Button from 'react-bootstrap/Button';

export const Modal = ({ show, source }) => {
	const isTwoTen = source === "2-10";
	const portalName = isTwoTen ? "Homeowner Portal" : "MyAccount";
	const portalUrl = isTwoTen
		? "https://myaccount.2-10.com/hb"
		: "https://www.ahs.com/my-account/pages/register.jsp/customer=true";

	return (
		<Popup open={show} modal>
			<center>
				<div>
					We encourage you to log into {portalName} to file a service
					request with your home warranty so we can inspect your
					current system and review your options with you.
				</div>
				<br />
				<br />
				<div>
					<b>CREATE YOUR SERVICE REQUEST NOW.</b>
				</div>
				<div className={isTwoTen ? "Background-twoten" : ""}>
					<Button size="lg" variant="primary" href={portalUrl}>
						Log into {portalName}
					</Button>
				</div>
			</center>
		</Popup>
	);
};